<template>
  <span class="badge gray !py-0 ml-2"><slot>Archived</slot></span>
</template>
